import { createContext, useContext, useState, useCallback } from "react";
import { translations } from "@/i18n";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("lang") || "en");
  const change = useCallback((code) => {
    setLang(code);
    localStorage.setItem("lang", code);
  }, []);
  const t = translations[lang] || translations.en;
  return (
    <LanguageContext.Provider value={{ lang, setLang: change, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLang() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
}
